import { ProductType } from '@/types';
import { StoreState } from '@/redux/types';

export const getProductTypeById = (state: StoreState, id: string): ProductType | undefined =>
  state.productTypes.detail[id];
